var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
import { PainIntensityEnum } from '../enums/pain-intensity.enum.js';
import { Icd10FullSizeDto } from './icd10.full-size.dto.js';
import { PainLocationFullSizeDto } from './pain-location.full-size.dto.js';
export class AnamnesisFullSizeDto {
    id;
    createdAt;
    updatedAt;
    updatedById;
    updatedBy;
    userId;
    user;
    icd10;
    icd10Id;
    symptomDescription;
    painSensations;
    painScale;
    painDuration;
    secondarySymptoms;
    painTrigger;
    painOccurrences;
    painIntensity;
    painRadiation;
    additionalFactors;
    successTarget;
    painLocations = [];
    get userOfficeId() {
        return this.user?.officeId;
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], AnamnesisFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], AnamnesisFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisFullSizeDto.prototype, "updatedById", void 0);
__decorate([
    IsUUID(),
    Expose(),
    Type(() => UserProfileDto),
    __metadata("design:type", Function)
], AnamnesisFullSizeDto.prototype, "updatedBy", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], AnamnesisFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], AnamnesisFullSizeDto.prototype, "user", void 0);
__decorate([
    IsObject(),
    Type(() => Icd10FullSizeDto),
    Expose(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "icd10", void 0);
__decorate([
    IsUUID(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "icd10Id", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "symptomDescription", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painSensations", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painScale", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painDuration", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "secondarySymptoms", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painTrigger", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painOccurrences", void 0);
__decorate([
    IsEnum(PainIntensityEnum),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painIntensity", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "painRadiation", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "additionalFactors", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], AnamnesisFullSizeDto.prototype, "successTarget", void 0);
__decorate([
    IsArray(),
    Type(() => PainLocationFullSizeDto),
    Expose(),
    IsOptional(),
    __metadata("design:type", Array)
], AnamnesisFullSizeDto.prototype, "painLocations", void 0);
//# sourceMappingURL=anamnesis.full-size.dto.js.map